<template>
    <!-- 个人中心 一行的组件 -->
    <table border="1" cellpadding="0" cellspacing="0" style="border-collapse:collapse" >
            <tr>
              <td>
                <div>
                  <img :src="imgSrc">
                  <span>{{title}}</span>
                </div>
                <span style="color:blue">{{coreValue}}</span>
                <el-button type="primary" round @click="btnClick">{{btnValue}}</el-button>
              </td>
            </tr>
    </table>
</template>

<script>
export default {
  props: {
    imgSrc: {
      default: ''
    },
    title: {
      default: ''
    },
    coreValue: {
      default: ''
    },
    btnValue: {
      default: ''
    }
  },
  data() {
    return {

    }
  },
  methods: {
    btnClick() {
      this.$emit('btn-click')
    }
  }
}
</script>

<style scoped lang="scss">
table{
  // display: flex;
  font-size: 20px;
  width: 100%;
  height: 100%;
  border:#c9c9c9;
  margin-top: 10px;
}

tr td{
  width: 100%;
  height: 80px;
  display: flex;
  border:1px solid #dddddd;
  justify-content: space-between;
  align-items: center;
  > div {
    display: flex;
    align-items: center;
    width: 250px;
    img{
      width: 50px;
      height: 50px;
      margin-left: 20%;
    }
    span{
      margin-left: 15%;
    }
  }
  .el-button{
  width: 140px;
  text-align: center;
  margin-right: 5%;
}
}
span{
  margin-right: 5%;
}
</style>
